/**
* A set of constants for the Astro library
*/
export const DEGTORAD = Math.PI / 180;
export const TWOPI = Math.PI * 2;
export const HALFPI = Math.PI / 2;
export const RADTODEG = 180 / Math.PI;
export const ARCSECTORAD = DEGTORAD / 3600.0; // Arc seconds to radians conversion factor
export const AU = 149597870.66; // Astronomical Unit in km
export const OBLIQUITY_2000 = 23.43929111 * DEGTORAD;
export const CLIGHT = 299792.458; // Speed of light in km/s





// WEBPACK FOOTER //
// ./src/Constants.ts